import * as React from 'react';
import LeaseGenerationOwnerData from 'src/models/leasing/LeaseGenerationOwnerData';
import Form from 'src/components/controls/forms/Form';
import FormTextBox from 'src/components/controls/forms/redesign/FormTextbox';
import FormSelect from 'src/components/controls/forms/redesign/FormFilterSelect';
import PropertyUtil from 'src/util/PropertyUtil';
import PagedResultSet from 'src/models/common/PagedResultSet';
import State from 'src/models/State';
import { SelectItem } from 'src/models/common/SelectItem';
import { AnyObject } from 'react-final-form';
import * as _ from 'lodash';
import Button from 'src/components/controls/forms/redesign/FormButton';
import OwnerStateLand from 'src/models/tract_detail/add_ownership_revised/OwnerStateLand';
import { FormApi } from 'final-form';
import MultiplePhoneNumber from '../TractComponents/MultiplePhoneNumber';
import PhoneNumberType from 'src/models/PhoneNumberType';
import Suffixes from 'src/models/Suffixes';
import Prefixes from 'src/models/Prefixes';
import FormCheckbox from 'src/components/controls/forms/redesign/FormCheckbox';

interface IStateLandOwnerFormProps {
    handleOnSubmit: (formValues: OwnerStateLand) => void;
    ownerData: LeaseGenerationOwnerData;
    states: PagedResultSet<State>;
    phoneNumberTypes: Array<PhoneNumberType>;
}

interface IStateLandOwnerFormState {
    form: FormApi;
}

class StateLandOwnerForm extends React.Component<IStateLandOwnerFormProps, IStateLandOwnerFormState> {
    constructor(props: IStateLandOwnerFormProps) {
        super(props);
        this.state = { form: undefined };
    }

    componentWillUnmount(): void {
        this.setState({ form: undefined });
    }

    validateForm = (values: AnyObject) => {
        const errors: AnyObject = {};
        if (!_.get(values, 'stateLandOwner.stateId')) {
            _.set(errors, 'stateLandOwner.stateId', 'Required');
        }
        if (!_.get(values, 'stateLandOwner.agencyName')) {
            _.set(errors, 'stateLandOwner.agencyName', 'Required');
        }
        if (!_.get(values, 'stateLandOwner.contactPersonFirstName')) {
            _.set(errors, 'stateLandOwner.contactPersonFirstName', 'Required');
        }
        if (!_.get(values, 'stateLandOwner.contactPersonLastName')) {
            _.set(errors, 'stateLandOwner.contactPersonLastName', 'Required');
        }
        return errors;
    };

    parseOwnerDetailFormValues = (formValues: AnyObject) => {
        const updatedOwnerDetail = new OwnerStateLand(formValues.stateLandOwner);
        this.props.handleOnSubmit(updatedOwnerDetail);
    };

    public render() {
        const states = PropertyUtil.SafeGet(() => this.props.states.items);
        const selectStates = states ? states.map((state: State) => new SelectItem(state.id, state.name)) : new Array<SelectItem>();
        const stateLandOwner = this.props.ownerData.ownerDetails as OwnerStateLand;

        return (
            <div>
                <h2 style={{marginLeft: '3rem'}}>State Land Owner Form</h2>
                <Form
                    onSubmit={this.parseOwnerDetailFormValues}
                    style={{padding: '3rem'}}
                    initialValues={{ stateLandOwner: stateLandOwner }}
                    validate={this.validateForm}
                    onFormCreated={(form) => {
                        this.setState({ form: form });
                    }}
                    hasFieldArray={true}
                >
                    <div>
                        <FormSelect 
                            name="stateLandOwner.stateId" 
                            label="State" 
                            items={selectStates} 
                            className="lh-third-width" 
                            isRequired={true} 
                        />
                        <FormTextBox 
                            name="stateLandOwner.agencyName" 
                            label="Agency Name" 
                            className="lh-third-width" 
                            isRequired={true} 
                        />
                        <FormTextBox 
                            name="stateLandOwner.ssnTaxId" 
                            label="Tax Id" 
                            className="lh-third-width" 
                            style={{marginLeft: '.5rem'}} 
                        />
                    </div>
                    <fieldset style={{ padding: '.3rem 0', borderWidth: '1px 0 0 0', marginBottom: '.2rem' }}>
                        <legend style={{ marginBottom: '1.25rem', marginLeft: '1rem' }}>Contact Person</legend>
                    </fieldset>
                    <div>
                        <FormTextBox    
                            name="stateLandOwner.contactPersonFirstName" 
                            label="First Name" 
                            className="lh-third-width" 
                            isRequired={true} 
                        />
                        <FormTextBox 
                            name="stateLandOwner.contactPersonMiddleName" 
                            label="Middle Name" 
                            className="lh-third-width" 
                        />
                        <FormTextBox 
                            name="stateLandOwner.contactPersonLastName" 
                            label="Last Name" 
                            className="lh-third-width" 
                            isRequired={true} 
                            style={{marginLeft: '.5rem'}} 
                        />
                    </div>
                    <div>
                        <FormSelect 
                            name="stateLandOwner.contactPersonPrefix" 
                            label="Prefix" 
                            items={Prefixes} 
                            className="lh-third-width" 
                        />
                        <FormSelect 
                            name="stateLandOwner.contactPersonSuffix" 
                            label="Suffix" 
                            items={Suffixes} 
                            className="lh-third-width" 
                        />
                        <FormTextBox 
                            name="stateLandOwner.email" 
                            label="Email" 
                            className="lh-third-width" 
                            style={{marginLeft: '.5rem'}} 
                        />
                    </div>
                    <fieldset style={{ padding: '.3rem 0', borderWidth: '1px 0 0 0', marginBottom: '.2rem' }}>
                        <legend style={{ marginBottom: '1.25rem', marginLeft: '1rem' }}>Address</legend>
                    </fieldset>
                    <div>
                        <FormTextBox 
                            name="stateLandOwner.address.addressLine1" 
                            label="Address Line 1" 
                            className="lh-half-width" 
                        />
                        <FormTextBox 
                            name="stateLandOwner.address.addressLine2" 
                            label="Address Line 2" 
                            className="lh-half-width" 
                        />
                    </div>
                    <div>
                        <FormTextBox 
                            name="stateLandOwner.address.city" 
                            label="City" 
                            className="lh-third-width" 
                        />
                        <FormSelect
                            name="stateLandOwner.address.stateId"
                            label="State"
                            items={selectStates}
                            className="lh-third-width"
                        />
                        <FormTextBox 
                            name="stateLandOwner.address.zipCode" 
                            label="Zip Code" 
                            className="lh-third-width" 
                            style={{marginLeft: '.5rem'}} 
                        />
                    </div>
                    <div>
                        <FormCheckbox 
                            name="stateLandOwner.isClientAcreage" 
                            label="This is the Client"  
                        />
                    </div>
                    <div style={{marginLeft: '.5rem'}}>
                        <MultiplePhoneNumber 
                            baseFieldName="stateLandOwner" 
                            form={this.state.form} 
                            phoneNumberTypes={this.props.phoneNumberTypes} 
                        />
                    </div>
                    <div className="button-row">
                        <Button 
                            text="Save" 
                            type="submit" 
                            intent="primary"
                            style={{marginLeft: '.5rem'}} 
                        />
                    </div>
                </Form>
            </div>
        );
    }
}

export default StateLandOwnerForm;



// WEBPACK FOOTER //
// ./src/components/project/sections/owners/StateLandOwnerForm.tsx